import AddPage from './AddPage.js'
import { BasePage as CngBasePage } from 'cng-web-lib'
import EditPage from './EditPage.js'
import React from 'react'
import TablePage from './TablePage.js'
import ViewPage from './ViewPage.js'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'
import ACEHighwayTranslationProvider from '../contexts/ACEHighwayTranslationContext.js'

function WrappedTablePage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ACEHighwayTranslationProvider>
          <TablePage showNotification={showSnackbar} {...props} />
        </ACEHighwayTranslationProvider>
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

function WrappedAddPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
          <ACEHighwayTranslationProvider>
            <AddPage showNotification={showSnackbar} {...props} />
          </ACEHighwayTranslationProvider>
        )}
        extraCngBreadcrumbNameMap={breadcrumbNameMap}
      />
    )
  }

function WrappedEditPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
          <ACEHighwayTranslationProvider>
            <EditPage showNotification={showSnackbar} {...props} />
          </ACEHighwayTranslationProvider>
        )}
        extraCngBreadcrumbNameMap={breadcrumbNameMap}
      />
    )
  }

function WrappedViewPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
          <ACEHighwayTranslationProvider>
            <ViewPage showNotification={showSnackbar} {...props} />
          </ACEHighwayTranslationProvider>
        )}
        extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

export {
  WrappedAddPage as AddPage,
  WrappedEditPage as EditPage,
  WrappedViewPage as ViewPage,
  WrappedTablePage as TablePage
}
